import { menuselect } from "@/constant/menuselect";
let str = "构建运营管理指标体系";
export const config = {
  title: "运营数据中心(ODR)",
  headerInfo:
    "医院运营数据中心（ODR）作为业务系统和财务系统的交汇，通过将医院海量运营数据经过“集成-治理-建模-服务”，把数据变成资产并服务于医院业务，为管理决策赋能，创造增量价值，助力各级医院实现智慧决策支持。",
  headerImg: require("@/assets/images/odr_system/odr_system_header.png"),
  activeTitle: str,
  activeSubTitle: str,
  navList: [
    {
      name: "运营数据中心",
      children: menuselect(),
    },
    {
      name: "产品概述",
      desc: "近年来，国家出台了多项政策文件鼓励“互联网+医疗健康”，医院要从数字化医疗走向智慧医疗，实现面向医务人员的智慧诊疗、面向患者的智慧服务、面向医院管理的智慧管理。要打造智慧医院，一定要用数据来说话，必须将医院的沉淀数据转化为数据资产，实现数据的智慧化，更好服务于医院内部运营。医院运营数据中心（ODR）作为业务系统和财务系统的交汇，通过将医院海量运营数据经过“集成-治理-建模-服务”，把数据变成资产并服务于医院业务，为管理决策赋能，创造增量价值，助力各级医院实现智慧决策支持。",
      tabList: [{}],
      [str]: [
        {
          title: "",
          desc: " ",
          img: require("@/assets/images/odr_system/Frame 936one.svg"),
        },
        {
          title: "",
          desc: " ",
          img: require("@/assets/images/odr_system/Group 944one.svg"),
        },
      ],
    },
    {
      name: "产品功能",
      desc: "ODR提升了医院经济管理职能的作用，以大数据平台为基础，体现医院运营管理的“运营战略家”价值。以指标概览、溯源钻取，报表智能分析等为手段，全景、全局管理医院整体、科室运营状况。以集成数据架构做支撑，目标规划为方向，绩效为引领，医保支付为调节手段，夯实财务基础，落实国考指标优化，依托创新提高效能。 运营数据中心通过医院运营主题分析、运营管理驾驶舱、指标动态实时监控、移动及大屏可视化应用等，进一步为医院管理者提供运营辅助决策支持。",
      tabList: [{}],
      [str]: [
        {
          title: "运营数据中心建设内容",
          desc: "建立医院数据中心，专业化存储医院云管理方面数据。以信息平台集成为主要工具，打破医院壁垒，促进互联互通、信息共享和业务协同，以数据流引领技术流、物资流、资金流、人才流，打造跨部门、跨区域、跨层级、跨系统的数据交换与共享。建立医院运营管理门户，在应用层面发挥医院运营管理和数据平台价值。",
          img: require("@/assets/images/odr_system/Group 885two.svg"),
        },
        {
          title: "驱动医院运营管理体系升级",
          desc: "以集成平台和数据中心为基础底座，以数据中心服务总线架构，构建新一代医院运营管理信息系统，结合统一门户、安全管理、新技术拓展等技术手段，实现对9 大类业务，45 级 163 个功能点的全面支撑。满足及时精准数据上报，支持集团化管控，驱动医院运营管理体系全面升级。",
          img: require("@/assets/images/odr_system/Group 884two.svg"),
        },
      ],
    },
    {
      name: "应用价值",
      tabList: [
        { name: "构建运营管理指标体系" },
        { name: "搭建数据分析平台" },
        { name: "全方位辅助决策" },
        { name: "深挖数据价值" },
      ],
      构建运营管理指标体系: [
        {
          title: "运营为导向，财务为抓手，业务为基础，搭建全面运营管理指标体系",
          desc: " ",
          img: require("@/assets/images/odr_system/Frame 955t1.svg"),
        },
        {
          title: "业财双驱，医运共建，层层递进引领医院建设方向的全方位指标库",
          desc: " ",
          img: require("@/assets/images/odr_system/Group 958t1.svg"),
        },
      ],
      搭建数据分析平台: [
        {
          title: "构建运营数据中心，发挥“运营战略家”价值",
          desc: " ",
          img: require("@/assets/images/odr_system/Group 455t2.svg"),
        },
        {
          title: "敬在运营数据中心系统构建蓝图",
          desc: " ",
          img: require("@/assets/images/odr_system/Group 447t2.svg"),
        },
      ],
      全方位辅助决策: [
        {
          title: "敬在ODR——构建运营能效评估与提升中心",
          desc: " ",
          img: require("@/assets/images/odr_system/Frame 428t3.svg"),
        },
        {
          title: "敬在ODR——构建医院价值医疗指标",
          desc: "通过医疗和运营数据资源获取，发现并定位医院诊疗行为与资源的关系，构建医院价值医疗指标。",
          img: require("@/assets/images/odr_system/Group 522t3.svg"),
        },
        {
          title: "辅助经营决策——领导驾驶舱",
          desc: "从收入情况、成本情况、资源配置、运行效率、费用负担、偿债能力、预算管理、发展能力等各个方面全方位关注区域卫生资源静态及动态情况，掌握医疗机构卫生资源构成及分布情况，促进区域医疗卫生资源均衡发展，辅助做强区域医疗卫生优势。",
          img: require("@/assets/images/odr_system/Group 961t3.svg"),
        },
        {
          title: "科室经营助手",
          desc: "基于数据服务平台，快速构建应用模型，帮助院科两级分析、管理、考核等深层次应用。",
          img: require("@/assets/images/odr_system/Group 487t3.svg"),
        },
        {
          title: "员工360经营助手",
          desc: "针对加入医院的每一位员工，搭建员工自助经营助手，涵盖员工自身的全部360信息画像，搭建员工自测评价模型，帮助员工进行自我成长。",
          img: require("@/assets/images/odr_system/Group 715t3.svg"),
        },
        {
          title: "应用主题-部分示例——财务指标总览",
          desc: "展示全院财务结构、趋势及相关运营指标，整体把握财务状况。 分析全院收入结构，分析财政、医疗、科教收入状况；展示全院收入月变化趋势，分析不同类别收入的变化规律，辅助财务预测及决策。 展示全院费用月变化趋势，分析全院、业务活动费用及单位管理费用的变化规律，监测费用异常变动。 按照盈余分类反映收支结余构成情况，按收入、费用反映对结余变化的影响。",
          img: require("@/assets/images/odr_system/Group 962t3.svg"),
        },
        {
          title: "预算指标总览",
          desc: "针对预算编制与执行的对比情况，月度执行情况以及按预算单元维度查看科室的编制与执行情况进行分析。",
          img: require("@/assets/images/odr_system/Group 963t3.svg"),
        },
        {
          title: "人事指标总览",
          desc: "针对人员资源的基本情况进行结构性分析、对于关键性人才进行重点关注，对人力资源的成本及效益进行对比分析。",
          img: require("@/assets/images/odr_system/Group 964t3.svg"),
        },
        {
          title: "物资指标总览",
          desc: "通过对医院物资的、库存情况进行分析，帮助了解库存占用情况，辅助医院进行库存成本优化决策。 通过药品、耗材、试剂的进销存变动统计和关键库存指标，帮助医院了解库存动销情况，并可通过横向同比、环比对比不同时期的库存管理提升情况。",
          img: require("@/assets/images/odr_system/Group 965t3.svg"),
        },
        {
          title: "资产指标总览",
          desc: "全面展示医院的当前固定资产、无形资产基本情况和各维度构成情况，帮助医院了解资产的整体管理状态，以及设备运行效益情况。",
          img: require("@/assets/images/odr_system/Group 966t3.svg"),
        },
        {
          title: "临床指标概览",
          desc: "临床指标主要包括 医疗质量指标和医疗纠纷处理指标；辅助区域管理者清楚掌握区域内的质量服务情况，并且对各类机构进行对比和趋势分析，掌握各类机构的医疗质量改善状况，和机构间的医疗质量差异，进而帮助管理者协调资源，提升医疗服务满意度。",
          img: require("@/assets/images/odr_system/Group 967t3.svg"),
        },
      ],
      深挖数据价值: [
        {
          title: "1.业务流程诊断",
          desc: "业务流程沉淀数据，基于数据分析对现有业务流程进行诊断，借助流程机器人的应用，对流程进行针对性优化，达到医院运营闭环管理。",
          img: require("@/assets/images/odr_system/img_prduct_content1.svg"),
        },
        {
          title: "2.业务流程优化",
          desc: "以费用报销流程示例：",
          img: require("@/assets/images/odr_system/img_prduct_content2.svg"),
        },
        {
          title: "3.量化运营提升成果",
          desc: "费用报销流程，优化效果评估。",
          img: require("@/assets/images/odr_system/img_prduct_content3.svg"),
        },
      ],
    },
  ],
};
